import { CerFormAdapter } from '@form/cer-form-adapter';
import { CerFormView } from '@form/cer-form-view';
import { FieldWidthEnum } from '@data/cer-data-types';

export class BankCreditCardForm extends CerFormAdapter {

  public override view(): CerFormView {
    return new CerFormView({
      viewMetadata: {
        name: 'kreditkort', dataApiName: 'BankCreditCard', text: 'Kreditkort',
        primaryKey: 'id', baseFields: ['id', 'history']
      },
      fieldMetadata: [
        { name: 'name', text: 'Navn', tooltipText: 'Navn på kreditkort', widthType: FieldWidthEnum.L, required: true },
        { name: 'cardNumber', text: 'Kortnr.', required: true },
        { name: 'cardNumberPublic', text: 'Kortnr. anonymt', required: false }, // Auto-init on save
        { name: 'bankAccount', text: 'Bankkonto', foreignKeyTableName: 'BankAccount', required: true },
        { name: 'user', text: 'Udstedt til', foreignKeyTableName: 'User', foreignKeyField: 'id', foreignKeyValue: 'shortName' },
        { name: 'active', text: 'Aktiv', format: 'CheckBox' }
      ]
    });
  }
}
